import { Checkbox, Button, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../i18n/i18n.constants";

const DaolInvPage: React.FC = () => {
  const history = useHistory();
  const [isCheckAccept, setIsCheckAccept] = useState(false);
  const { t } = useTranslation(namespaces.pages.daolinv);
  const dt = new Date();
  const checkAccept = (e) => {
    setIsCheckAccept(e.target.checked);
    console.log(`checked = ${isCheckAccept}`);
  };

  return (
    <>
      <Row className="row container-main container-daolinv">
        <div className="content-left col-sm-5">
          <div className="info-left">
            <p className="text-center text-header">
              {/* {t("welcome")} */}
              {t("title")}
            </p>
            <p>{t("text_descrip")}</p>
          </div>
        </div>
        <div className="content-right col-sm-7">
          <p className="text-center text-header">{t("descrip_header")}</p>
          <p className="text-center text-header">{t("title_company")}</p>
          <p>{t("descrip_p1")}</p>
          <p>{t("descrip_p2")}</p>
          <p>
            <Checkbox className="checkbox" onChange={checkAccept}>
              {t("check_accept")}
            </Checkbox>
          </p>
          <p className="container-button">
            {isCheckAccept === false ? (
              <Button type="primary" disabled>
                {t("btn_informed")}
              </Button>
            ) : (
              <Button
                type="primary"
                onClick={() => history.push(`/contents/daolInv/consentRMF/loginMember`)}
              >
                {t("btn_informed")}
              </Button>
            )}
          </p>
        </div>
      </Row>
    </>
  );
};
export default DaolInvPage;
